import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import format from "date-fns/format"
import React, { useCallback, useState } from "react"
import DatePicker from "react-date-picker"
import { UserPastAttendanceRecordsQueryVariables, useUserPastAttendanceRecordsQuery } from "../../graphql"
import { Card } from "../common"
import { UserAttendancesList } from "./UserAttendancesList"

export type UserPastAttendancesProps = {
	userId: string
}

export const UserPastAttendances: React.FC<UserPastAttendancesProps> = ({ userId }) => {
	const [date, setDate] = useState(new Date(format(new Date(), "MM/dd/yyyy")))
	const [pagination, setPagination] = useState<UserPastAttendanceRecordsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error, stale }] = useUserPastAttendanceRecordsQuery({ variables: { userId, pagination, date } })

	const nextPage = useCallback(() => {
		if (data?.userPastAttendanceRecords.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data])

	return (
		<Card title="Past Attendances" alwaysShowAction action={<DatePicker onChange={setDate} value={date} format="MMM dd, y" maxDate={new Date()} clearIcon={null} />}>
			{(fetching && !data?.userPastAttendanceRecords) || stale ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading past attendances</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.userPastAttendanceRecords.userAttendanceRecords.length ? (
				<VStack w="full" align="stretch">
					<UserAttendancesList userAttendanceRecords={data.userPastAttendanceRecords.userAttendanceRecords} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more records</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="md" color="error.500">
						Couldn&apos;t find past attendances
					</Text>
				</Center>
			)}
		</Card>
	)
}
